// This file was previously called objSidebar.php.  The original objSidebar.php had a field
// SidebarPageManager, and so does this, but the file now named after it.
import DocsManager from './docsManager'
import { GLOBALS } from '../types'

class LinkObj2 { // TODO This can be changed to just LinkObj
  key:string
  text:string
  type:string
  url:string
  /* eslint-disable @typescript-eslint/no-explicit-any */
  constructor (key:string, text:string, type:string, thing:any) {
    this.key = key
    this.text = text
    this.type = type
    this.url = typeof thing === 'string' ? thing : URL.createObjectURL(thing)
  }
}
export default class SidebarPageManager {
  pageManagers: {[index: string]:SidebarObj2} = {}
  docsManager:DocsManager
  techList:Array<LinkObj2>
  constructor (docsManager:DocsManager) {
    this.pageManagers = {}
    this.docsManager = docsManager
    this.techList = []
  }

  addPage (pageKey:string):SidebarObj2 {
    this.pageManagers[pageKey] = new SidebarObj2(pageKey)
    return (this.getSidebar(pageKey))
  }

  getSidebar (pageKey:string):SidebarObj2 {
    return (this.pageManagers[pageKey])
  }

  load () {
    // Blog objects
    const g_blogspotLinkObj:LinkObj2 = new LinkObj2('elevatorMusic', 'Sealed Tuna Sandwich', 'external', 'http://gregsandell.blogspot.com')

    // Wow these are so old...
    /*
        const g_mavenBlogObj = new BlogObj2("maven", "Maven 2 Tutorial", 'external',
                "http://gregsandell.blogspot.com/2007/07/maven2-introduction-part-1-coordinate.html",
                "2007.07.13");
        const g_scorpBlogObj = new BlogObj2("scorp", "S-Corps for Software Contracters", 'external',const
                "http://gregsandell.blogspot.com/2006/10/s-corps-for-software-contracters.html",
                "2006.10.22");
        const g_roxyBlogObj = new BlogObj2("roxy", "New Roxy & Elsewhere Vid", 'external',const
                "http://gregsandell.blogspot.com/2017/06/new-roxy-elsewhere-video.html",
                "2017.06.29");
        const g_twinpeaksBlogObj = new BlogObj2("roxy", "Twin Peaks Season 3", 'external',const
                "http://gregsandell.blogspot.com/2017/06/dont-die-twin-peaks-s03e06-spoiler.html",
                "2017.06.26");
        const g_charsetLinkObj = new BlogObj2("characters", "Solving Character Set Problems", 'external',
                "http://gregsandell.blogspot.com/2009/01/solving-character-set-problems-ascii.html",
                "2009.05.15");
        const g_washingmachineBlogObj = new BlogObj2("washingMachine", "The Washing Machine", 'external',
                "http://gregsandell.blogspot.com/2017/02/the-washing-machine.html",
                "2017.02.23");
        */

    // Newer blogs
    const g_elAmorBrujoBlogObj = new BlogObj2('elAmorBrujo', 'El Amor Brujo Concert Review', 'external',
      'http://gregsandell.blogspot.com/2019/11/santa-cecilia-orchestra-el-amor-brujo.html',
      '2019.11.11')
    const g_milkyWayBlogObj = new BlogObj2('milkyWay', 'My Trip Through the Milky Way', 'external',
      'http://gregsandell.blogspot.com/2018/11/my-trip-through-milky-way.html',
      '2018.11.21')
    const g_zappa1971BlogObj = new BlogObj2('zappa1971', 'Frank Zappa Concert, 1971', 'external',
      'http://gregsandell.blogspot.com/2018/03/remembering-frank-zappa-and-mothers-in.html',
      '2018.03.03')
    const g_jellyRollBlogObj = new BlogObj2('jellyRoll', 'Jelly Roll Morton', 'external',
      'http://gregsandell.blogspot.com/2018/02/get-to-know-jelly-roll-morton.html',
      '2018.02.17')
    const g_appleHomepodBlogObj = new BlogObj2('appleHomepod', 'Apple\'s HomePod: Review', 'external',
      'http://gregsandell.blogspot.com/2018/02/review-of-apples-homepod.html',
      '2018.02.12')
    const g_cecliaReviewBlogObj = new BlogObj2('ceciliaReview', 'Beethoven & Handel Concert Review', 'external',
      'http://gregsandell.blogspot.com/2018/02/santa-cecilia-orchestra-plays-beethoven.html',
      '2018.02.12')
    const g_mahavishnuBlogObj = new BlogObj2('mahavishnuReview', 'Mahavishnu Returns Concert Review', 'external',
      'http://gregsandell.blogspot.com/2017/12/mahavishnu-returns-royce-hall-ucla-2017.html',
      '2017.12.19')

    // Internal URLs
    const g_publicationsLinkObj:LinkObj2 = new LinkObj2('publications', 'Publications', 'internal', '/publications')
    const g_portfolioPageObj:LinkObj2 = new LinkObj2('samples', 'Main Portfolio Page', 'internal', `/portfolio/${GLOBALS.lastClient}/splash`)
    // const g_billwhitneyLinkObj:LinkObj2 = new LinkObj2('billwhitney', 'Archived Live Site (MSIE Only)', 'internal', '/portfolio/samples/bwhitney')
    const g_resumeLinkObj:LinkObj2 = new LinkObj2('resume', 'Resume', 'internal', '/resume')
    const g_talksLinkObj:LinkObj2 = new LinkObj2('talks', 'Talks', 'internal', '/talks')
    const g_codeLinkObj:LinkObj2 = new LinkObj2('code', 'Code', 'internal', '/code')

    // PDFs
    const g_dissertationLinkObj:LinkObj2 = new LinkObj2('dissertation', 'PhD Dissertation', 'internal', '/dissertation')
    const g_mastersThesisLinkObj:LinkObj2 = new LinkObj2('mastersThesis', 'Masters Thesis', 'internal', '/thesis')
    const g_pcaLinkObj:LinkObj2 = new LinkObj2('pca', 'Timbre with PCA', 'internal-static', this.docsManager.get('1995-12-01_perceptual_JAES'))
    const g_displayLinkObj:LinkObj2 = new LinkObj2('display', 'Auditory Displays', 'internal-static', this.docsManager.get('1996-06-01_auditory_MP'))
    const g_macroLinkObj:LinkObj2 = new LinkObj2('macro', 'Macro Timbre', 'internal-static', this.docsManager.get('1997-06-07_perceptual_ESCOM'))
    const g_pdfObj:LinkObj2 = new LinkObj2('pdfFormat', 'PDF Format', 'internal-static-download', this.docsManager.get('resumePdf'))

    // External Websites
    const g_linkedInObj = new LinkObj2('linkedIn', 'Linked In Profile', 'external', 'https://www.linkedin.com/in/gregsandell')
    const g_maxtradObj = new LinkObj2('maxtrad', 'Official MaxTrad Site', 'external', 'http://www.maxtrad.com')
    const g_iesLinkObj = new LinkObj2('iesLive', 'Live IES Site', 'external', 'http://www.iesabroad.org')
    const g_maytagLinkObj = new LinkObj2('maytagLive', 'Live Maytag Site', 'external', 'http://www.maytag.com')
    const g_usafLinkObj = new LinkObj2('usafLive', 'Live AF Portal', 'external', 'http://www.my.af.mil')
    const g_wattsLinkObj = new LinkObj2('wattsLive', 'Live Watts Site', 'external', 'http://www.edwinwatts.org')
    const g_truvenLinkObj = new LinkObj2('trCompanySite', 'Live Truven Site', 'external', 'http://www.truvenhealth.com')
    const g_searsLinkObj = new LinkObj2('searsCompanySite', 'Live sears.com', 'external', 'http://www.sears.com')
    const g_tenxLinkObj = new LinkObj2('tenxCompanySite', 'Live auction.com', 'external', 'http://www.auction.com')
    const g_crocsLinkObj = new LinkObj2('crocsCompanySite', 'Live crocs.com', 'external', 'https://crocs.com')
    const g_zillowLinkObj = new LinkObj2('zillowLiveSite', 'Live Zillow.com', 'external', 'https://zillowhomeloans.com')
    const g_fashionnovaLinkObj = new LinkObj2('fashionnovaLiveSite', 'Live FashionNova.com', 'external', 'https://fashionnova.com')
    const g_ciandtLinkObj = new LinkObj2('ciandtLiveSite', 'Live CIandT.com', 'external', 'https://ciandt.com')
    const g_pathfinderLinkObj = new LinkObj2('pathfinderCompanySite', 'Live site', 'external', 'https://orthogonal.io')

    // MS-Word docs
    const g_mswordObj:LinkObj2= new LinkObj2('mswordResume', 'MS Word Format', 'external', this.docsManager.get('resumeMsWordDoc'))

    // technology pages (for SEO)
    const g_tech_angular:LinkObj2= new LinkObj2('angular', 'Angular', 'internal', '/tech/angular')
    this.techList.push(g_tech_angular)
    const g_tech_bootstrap:LinkObj2= new LinkObj2('bootstrap', 'Bootstrap', 'internal', '/tech/bootstrap')
    this.techList.push(g_tech_bootstrap)
    const g_tech_css:LinkObj2= new LinkObj2('css', 'CSS', 'internal', '/tech/css')
    this.techList.push(g_tech_css)
    const g_tech_curl:LinkObj2 = new LinkObj2('CuRL', 'CuRL', 'internal', '/tech/CuRL')
    this.techList.push(g_tech_curl)
    const g_tech_flexbox:LinkObj2 = new LinkObj2('flexbox', 'Flexbox', 'internal', '/tech/flexbox')
    this.techList.push(g_tech_flexbox)
    const g_tech_git:LinkObj2 = new LinkObj2('git', 'Git', 'internal', '/tech/git')
    this.techList.push(g_tech_git)
    const g_tech_html:LinkObj2 = new LinkObj2('html', 'HTML', 'internal', '/tech/html')
    this.techList.push(g_tech_html)
    const g_tech_javascript:LinkObj2 = new LinkObj2('javascript', 'Javascript/ES6', 'internal', '/tech/javascript')
    this.techList.push(g_tech_javascript)
    const g_tech_javascript_hoisting:LinkObj2 = new LinkObj2('javascript-hoisting', 'Javascript Hoisting', 'internal', '/tech/javascript-hoisting')
    this.techList.push(g_tech_javascript_hoisting)
    const g_tech_javascript_promises:LinkObj2 = new LinkObj2('javascript-promises', 'Javascript Promises', 'internal', '/tech/javascript-promises')
    this.techList.push(g_tech_javascript_promises)
    const g_tech_node:LinkObj2 = new LinkObj2('node.js', 'Node.js', 'internal', '/tech/node')
    this.techList.push(g_tech_node)
    const g_tech_performance_tuning:LinkObj2 = new LinkObj2('performance-tuning', 'Performance Tunine', 'internal', '/tech/performance-tuning')
    this.techList.push(g_tech_performance_tuning)
    const g_tech_react:LinkObj2 = new LinkObj2('react', 'React', 'internal', '/tech/react')
    this.techList.push(g_tech_react)
    const g_tech_react_hooks:LinkObj2 = new LinkObj2('react-hooks', 'React Hooks', 'internal', '/tech/react-hooks')
    this.techList.push(g_tech_react_hooks)
    const g_tech_redux:LinkObj2 = new LinkObj2('redux', 'Redux', 'internal', '/tech/redux')
    this.techList.push(g_tech_redux)
    const g_tech_responsive_design:LinkObj2 = new LinkObj2('responsive-design', 'Responsive Design', 'internal', '/tech/responsive-design')
    this.techList.push(g_tech_responsive_design)
    const g_tech_sequelize:LinkObj2 = new LinkObj2('sequelize', 'Sequelize', 'internal', '/tech/sequelize')
    this.techList.push(g_tech_sequelize)
    const g_tech_software_engineering:LinkObj2 = new LinkObj2('software-engineering', 'Software Engineering', 'internal', '/tech/software-engineering')
    this.techList.push(g_tech_software_engineering)
    const g_tech_sql:LinkObj2 = new LinkObj2('sql', 'SQL', 'internal', '/tech/sql')
    this.techList.push(g_tech_sql)
    const g_tech_webpack:LinkObj2 = new LinkObj2('webpack', 'WebPack', 'internal', '/tech/webpack')
    this.techList.push(g_tech_webpack)
    const g_tech_list:LinkObj2 = new LinkObj2('list', 'More...', 'internal', '/tech/list')

    //
    // pageHome.php
    //
    let page = this.addPage('pageHome')
    page.addLinkObj(g_tech_javascript)
    page.addLinkObj(g_tech_react)
    page.addLinkObj(g_tech_angular)
    page.addLinkObj(g_tech_node)
    page.addLinkObj(g_tech_redux)
    page.addLinkObj(g_tech_list)
    //
    // innerPagePublications.js
    //
    page = this.addPage('pagePublications')
    page.addLinkObj(g_mastersThesisLinkObj)
    page.addLinkObj(g_pcaLinkObj)
    page.addLinkObj(g_displayLinkObj)
    page.addLinkObj(g_macroLinkObj)
    //
    // innerPagePublications.js
    //
    page = this.addPage('pagePublications2')
    page.addLinkObj(g_dissertationLinkObj)
    page.addLinkObj(g_pcaLinkObj)
    page.addLinkObj(g_displayLinkObj)
    page.addLinkObj(g_macroLinkObj)
    //
    // pageBlogs.php
    //
    page = this.addPage('pageBlogs')
    page.addLinkObj(g_blogspotLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_milkyWayBlogObj)
    //
    // pageResume.js
    //
    page = this.addPage('pageResume')
    page.addLinkObj(g_mswordObj)
    page.addLinkObj(g_pdfObj)
    page.addLinkObj(g_linkedInObj)
    page.addLinkObj(g_codeLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_milkyWayBlogObj)
    page.addBlogObj(g_zappa1971BlogObj)
    page.addBlogObj(g_jellyRollBlogObj)
    page.addBlogObj(g_appleHomepodBlogObj)
    page.addBlogObj(g_cecliaReviewBlogObj)
    page.addBlogObj(g_mahavishnuBlogObj)

    //
    // pageMusic.js
    //
    page = this.addPage('pageMusic')
    page.addLinkObj(g_publicationsLinkObj)
    page.addBlogObj(g_elAmorBrujoBlogObj)
    page.addBlogObj(g_zappa1971BlogObj)
    page.addBlogObj(g_jellyRollBlogObj)
    page.addBlogObj(g_cecliaReviewBlogObj)
    page.addBlogObj(g_mahavishnuBlogObj)

    page = this.addPage('portfolio') // this is just so LinksArray will be empty array

    //
    // pagePortfolio
    //
    page = this.addPage('pagePortfolio')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_elAmorBrujoBlogObj)
    page.addLinkObj(g_publicationsLinkObj)
    page.addBlogObj(g_milkyWayBlogObj)

    // potpourri
    page = this.addPage('potpourri')
    page.addLinkObj(g_publicationsLinkObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_blogspotLinkObj)

    //
    // pageCode.js
    //
    page = this.addPage('pageCode')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_talksLinkObj)
    page.addLinkObj(g_resumeLinkObj)

    //
    // pageTalks
    //
    page = this.addPage('pageTalks')
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    page.addLinkObj(g_portfolioPageObj)

    //
    // CLIENT PAGES
    //
    //
    // pageClient_ciandt
    //
    page = this.addPage('pageClient_ciandt')
    page.addLinkObj(g_zillowLinkObj)
    page.addLinkObj(g_ciandtLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_fashionnova
    //
    page = this.addPage('pageClient_fashionnova')
    page.addLinkObj(g_fashionnovaLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_crocs
    //
    page = this.addPage('pageClient_crocs')
    page.addLinkObj(g_crocsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_tenx
    //
    page = this.addPage('pageClient_tenx')
    page.addLinkObj(g_tenxLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_sears
    //
    page = this.addPage('pageClient_sears')
    page.addLinkObj(g_searsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_path
    //
    page = this.addPage('pageClient_pathfinder')
    page.addLinkObj(g_pathfinderLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_tr
    //
    page = this.addPage('pageClient_truven')
    page.addLinkObj(g_truvenLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_abnAmro
    //
    page = this.addPage('pageClient_abnAmro')
    page.addLinkObj(g_maxtradObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_amex
    //
    page = this.addPage('pageClient_amex')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_billwhitney
    //
    page = this.addPage('pageClient_billwhitney')
    // page.addLinkObj(g_billwhitneyLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_ies
    //
    page = this.addPage('pageClient_ies')
    page.addLinkObj(g_iesLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_maytag
    //
    page = this.addPage('pageClient_maytag')
    page.addLinkObj(g_maytagLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)

    //
    // pageClient_ubs
    //
    page = this.addPage('pageClient_ubs')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_usaf
    //
    page = this.addPage('pageClient_usaf')
    page.addLinkObj(g_usafLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_watts
    //
    page = this.addPage('pageClient_watts')
    page.addLinkObj(g_wattsLinkObj)
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_xb
    //
    page = this.addPage('pageClient_xb')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
    //
    // pageClient_spectrum
    //
    page = this.addPage('pageClient_spectrum')
    page.addLinkObj(g_portfolioPageObj)
    page.addLinkObj(g_resumeLinkObj)
    page.addLinkObj(g_codeLinkObj)
  }
}
class SidebarObj2 {
  pageKey:string
  linksArray: {[index: string]:LinkObj2} = {}
  blogsArray: {[index: string]:BlogObj2} = {}
  constructor (pageKey:string) {
    this.pageKey = pageKey
    this.linksArray = {} // TODO change to linksHash
    this.blogsArray = {} // TODO change to blogsHash
  }

  // Dead code!
  // addLink (key:string, text:string, type:string, url:string) {
  //   this.linksArray[key]:LinkObj2 = new LinkObj2(key, text, type, url)
  // }
  //
  // addBlog (key:string, text:string, url:string, date:string) {
  //   this.blogsArray[key] = new BlogObj2(key, text, url, date)
  // }

  addLinkObj (linkObj:LinkObj2):void {
    this.linksArray[linkObj.key] = linkObj
  }

  addBlogObj (blogObj:BlogObj2):void {
    this.blogsArray[blogObj.key] = blogObj
  }
}
class BlogObj2 { // TODO This can be changed to just BlogObj
  key:string
  text:string
  type:string
  url:string
  date:string
  constructor (key:string, text:string, type:string, url:string, date:string) {
    this.key = key
    this.text = text
    this.type = type
    this.url = url
    this.date = date
  }
}
